function isMembershipValid(membership) {
    return isMembershipActive(membership) && isExpirationDateInFuture(membership);
}

function isMembershipActive(membership) {
    return !!membership && membership.membershipStatus === 'ACTIVATED';
}

function isExpirationDateInFuture(membership) {
    let {expirationDate} = membership;
    const today = new Date();
    expirationDate = new Date(expirationDate).getTime();
    return expirationDate > today;
}

function replaceAllParamsInKeys(keys, price, primeDiscount, renewalPrice, flightPrice, renewalDuration = 12, durationTimeUnit = 'MONTHS') {
    price = Odigeo.Utils.formatCurrency(price);
    primeDiscount = Odigeo.Utils.formatCurrency(primeDiscount);
    renewalPrice = Odigeo.Utils.formatCurrency(renewalPrice);
    const {durationAmount, durationUnit} = Odigeo.Utils.convertOfferToOfferDuration({
        renewalDuration,
        durationTimeUnit,
    },
    keys.subscriptionRenewalYear,
    keys.subscriptionRenewalMonthSingular,
    keys.subscriptionRenewalMonthPlural
    );

    return Object.entries(keys).reduce((acc, key) => {
        const keyName = key[0];
        const keyContent = key[1];
        const replacedContentByIndex = Odigeo.Utils.replaceCmsKeyArgs(
            keyContent,
            price,
            primeDiscount,
            renewalPrice,
            flightPrice);
        const replacedContentByIndexAndName = Odigeo.Utils.replaceCmsKeyArgsByName(
            replacedContentByIndex,
            {
                price,
                primeDiscount,
                renewalPrice,
                flightPrice,
                renewalTimeAmount: durationAmount,
                renewalTimeUnit: durationUnit,
            });

        return {...acc, [keyName]: replacedContentByIndexAndName};
    }, {});
}

function initData(isFullFareSelected = true, membershipFee) {
    const passengersData = Odigeo.Utils.parseJson(Odigeo.Session.get('passengersData'));
    const membershipDiscount = Odigeo.Utils.formatCurrency(Math.abs(membershipFee));
    const {name, firstLastName} = Odigeo._.get(passengersData, 'passengers0', {});
    return {
        isPrimeFareSelected: !isFullFareSelected,
        membershipDiscount,
        name,
        lastName: firstLastName,
    };
}

function isSubscriptionAdded(primeMemberSelected) {
    return !Odigeo._.isEmpty(primeMemberSelected) ? primeMemberSelected.isSubscriptionAdded : false;
}

module.exports = {
    isMembershipValid,
    isMembershipActive,
    isExpirationDateInFuture,
    replaceAllParamsInKeys,
    initData,
    isSubscriptionAdded,
};
